import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);
let store = new Vuex.Store({
    // 1. state
    requestURL:"",
    // 4. mutations
    mutations:{
        // state指的是state的数据
        // name传递过来的数据
        setRequestURL(state, name){
            state.requestURL = name;//将传参设置给state的city
        }
    }
});

export default store;
